
<div class="col-12">
    <h5 class="mt-5 text-center">
        {{ mensaje }}
    </h5>
    <br>
    <a class="btn mx-3 mt-4 text-center pb-1 btn-social bg-whatsapp text-white"
       href="{{href}}" target="_blank" *ngIf="!telefono; else conTelefono">
        <i class="fa fa-whatsapp"></i>      Whatsapp          
    </a>
    <ng-template #conTelefono>
        <a class="btn mx-3 mt-4 text-center pb-1 btn-social bg-whatsapp text-white" (click)="openWhatsApp($event)">
            <i class="fa fa-whatsapp"></i>      Whatsapp          
        </a>
    </ng-template>
</div>
